/**
 * Default: Vendors > Cookie consent
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

//import Matomo from './tools/matomo';

// -------
// Private
// -------

// const MatomoInstance = null;
/*const MatomoInstance = new Matomo(null, {
	// setCookieDomain : '*.relaunch.landkreis-nordsachsen.de',
	siteId       : (window.pageInstance.settings.statistic.matomo === undefined) ? 0 : window.pageInstance.settings.statistic.matomo.id,
	trackerDomain: (window.pageInstance.settings.statistic.matomo === undefined) ? '' : window.pageInstance.settings.statistic.matomo.library
	// Argumente `_paq.push` (beim Init und/oder der De-, Aktivierung)
	// Value = '', nur Schlüsselname übermitteln/setzen
	// Value = null, kein Schlüsselname übermitteln/setzen
	// Value != '' & != null, Schlüsselname mit Value übermitteln/setzen
	// paramsWhenInit   : {},
	// paramsWhenDisable: {},
	// paramsWhenEnable : {},
	// onEnable         : () => {},
	//onDisable         : () => {}
});*/

/*function consentGrantedAdStorage() {
	if (window.dataLayer !== undefined && typeof gtag === 'function') {
		window.dataLayer.push({
			// event: 'cookieOptInGoogleAds',
			'cookieOptInGoogleAds': true
		});

		gtag('consent', 'update', {
			'ad_storage'        : 'granted',
			'ad_user_data'      : 'granted',
			'ad_personalization': 'granted'
		});
	}
}

function consentDeniedAdStorage() {
	if (window.dataLayer !== undefined && typeof gtag === 'function') {
		window.dataLayer.push({
			'cookieOptInGoogleAds': false
		});

		gtag('consent', 'update', {
			'ad_storage'        : 'denied',
			'ad_user_data'      : 'denied',
			'ad_personalization': 'denied'
		});
	}
}

function consentGrantedAnalytics() {
	if (window.dataLayer !== undefined && typeof gtag === 'function') {
		window.dataLayer.push({
			event: 'cookieOptInGoogleAnalytics'
		});

		gtag('consent', 'update', {
			'analytics_storage': 'granted'
		});
	}
}

function consentDeniedAnalytics() {
	if (window.dataLayer !== undefined && typeof gtag === 'function') {
		window.dataLayer.push({
			'cookieOptInGoogleAnalytics': false
		});

		gtag('consent', 'update', {
			'analytics_storage': 'denied'
		});
	}
}*/

const checkCatMedia = (data) => {
	// Youtube
	const ytCollection = SelectorEngine.find('[data-player-type="youtube"]');
	for (const element of ytCollection) {
		EventHandler.trigger(element, `${data && data.includes('youtube') ? 'disable' : 'enable'}.privacyMode`);
	}

	// Vimeo
	const viCollection = SelectorEngine.find('[data-player-type="vimeo"]');
	for (const element of viCollection) {
		EventHandler.trigger(element, `${data && data.includes('vimeo') ? 'disable' : 'enable'}.privacyMode`);
	}

	// Googlemap
	const gmCollection = SelectorEngine.find('[data-gmap]');
	for (const element of gmCollection) {
		EventHandler.trigger(element, `${data && data.includes('googlemaps') ? 'disable' : 'enable'}.privacyMode`);
	}
};

/*const checkCatStatistic = (data) => {
	if (data && data.includes('googleanalytics')) {
		consentGrantedAnalytics();
	} else {
		consentDeniedAnalytics();
	}
};*/

/*const checkCatMarketing = (data) => {
	if (data && data.includes('googleads')) {
		consentGrantedAdStorage();
	} else {
		consentDeniedAdStorage();
	}
};*/

// ------
// Public
// ------

const init = () => {
	let inst = null;

	if (typeof ScCookie !== 'undefined') {
		inst = new ScCookie({
			on: {
				showPreferences: function () {
					lockBodyScrolling(this);
				},
				hidePreferences: function () {
					unlockBodyScrolling(this);
				},
				saveConsent: function () {
					// document.location.reload();
					checkCatMedia(this.getConsent('media'));
					//checkCatStatistic(this.getConsent('statistics'));
					//checkCatMarketing(this.getConsent('marketing'));
				},
				init: function () {
					checkCatMedia(this.getConsent('media'));
					//checkCatStatistic(this.getConsent('statistics'));
					//checkCatMarketing(this.getConsent('marketing'));
				}
			}
		});
	}

	// Video: Aktivieren und abspielen
	// EventHandler.on(document.body, 'click', '[data-privacy-enable]', (ev) => {
	// 	console.log(Manipulator.getDataAttribute(ev.delegateTarget, 'privacy-enable'));
	// });

	// Custom-Trigger für Cookie-Einstellungen anzeigen.
	EventHandler.on(document.body, 'click', '[data-privacy-settings]', (event) => {
		event.stopPropagation();

		window.ifabCookieConsent.togglePreferences();
	});

	return window.ifabCookieConsent = inst;
};

// Export
export default init;
